import { render, staticRenderFns } from "./OrderSummaryList.vue?vue&type=template&id=29f4f6ab"
import script from "./OrderSummaryList.vue?vue&type=script&lang=js"
export * from "./OrderSummaryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports